"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.defaultActionNames = void 0;

var _createReducer = _interopRequireDefault(require("../../creators/createReducer"));

var _onLoading = _interopRequireDefault(require("../../effects/onLoading"));

var _onSuccess = _interopRequireDefault(require("../../effects/onSuccess"));

var _onFailure = _interopRequireDefault(require("../../effects/onFailure"));

// TODO: Let the user specify selectors
var reducerDescription = {
  LOADING: (0, _onLoading["default"])(),
  SUCCESS: (0, _onSuccess["default"])(),
  FAILURE: (0, _onFailure["default"])()
};
var defaultActionNames = Object.keys(reducerDescription); // TODO: Let user specify this initialState

exports.defaultActionNames = defaultActionNames;

var _default = (0, _createReducer["default"])({}, reducerDescription);

exports["default"] = _default;